import React from 'react';
import { coachDisplayName } from './coachUtils';

const ICONS = {
  venue: (
    <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4" aria-hidden>
      <path d="M10 2a6 6 0 00-6 6c0 4.5 6 10 6 10s6-5.5 6-10a6 6 0 00-6-6zm0 8a2 2 0 110-4 2 2 0 010 4z" />
    </svg>
  ),
  attendance: (
    <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4" aria-hidden>
      <path d="M10 10a3 3 0 100-6 3 3 0 000 6zm-7 8a7 7 0 0114 0H3z" />
    </svg>
  ),
  referee: (
    <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4" aria-hidden>
      <path d="M10 2l1.5 4.5H16l-3.6 2.6 1.4 4.4L10 13l-3.8 2.5 1.4-4.4L4 6.5h4.5L10 2z" />
    </svg>
  ),
  coach: (
    <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4" aria-hidden>
      <path d="M4 16v-1h12v1H4zm2-3V7h2v6H6zm4 0V5h2v8h-2zm4 0V9h2v4h-2z" />
    </svg>
  ),
  kickoff: (
    <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4" aria-hidden>
      <path d="M10 2a8 8 0 100 16 8 8 0 000-16zm1 4v4l3 2-.8 1.2L9 10V6h2z" />
    </svg>
  ),
};

function MetaTile({ icon, label, value }) {
  if (!value) return null;
  return (
    <div className="sw-meta-tile">
      <span className="sw-meta-tile__icon" style={{ color: 'var(--sw-accent)' }}>
        {ICONS[icon]}
      </span>
      <div className="min-w-0 flex-1">
        <p className="sw-meta-tile__label">{label}</p>
        <p className="sw-meta-tile__value">{value}</p>
      </div>
    </div>
  );
}

export default function MatchMetaGrid({ match = {} }) {
  const venue = match.venue
    ? `${match.venue}${match.venueCity ? `, ${match.venueCity}` : ''}`
    : null;

  const tiles = [
    { icon: 'venue', label: 'Venue', value: venue },
    { icon: 'attendance', label: 'Attendance', value: match.attendance },
    { icon: 'referee', label: 'Referee', value: match.referee },
    {
      icon: 'coach',
      label: match.home || 'Home coach',
      value: coachDisplayName(match.coaches?.home),
    },
    {
      icon: 'coach',
      label: match.away || 'Away coach',
      value: coachDisplayName(match.coaches?.away),
    },
    { icon: 'kickoff', label: 'Kick-off', value: match.kickoff || (match.upcoming ? match.score : null) },
  ].filter((t) => t.value);

  if (!tiles.length) return null;

  return (
    <div className="px-4 pb-4">
      <div className="sw-meta-grid">
        {tiles.map((t) => (
          <MetaTile key={`${t.icon}-${t.label}`} icon={t.icon} label={t.label} value={t.value} />
        ))}
      </div>
    </div>
  );
}
